import { useState } from 'react'
import ConsumerUsers from './ConsumerUsers'
import ConsumerAnalytics from './ConsumerAnalytics'

type ConsumerTab = 'users' | 'analytics'

const TABS = [
  { key: 'users' as const, label: 'Users', icon: '👤' },
  { key: 'analytics' as const, label: 'Analytics', icon: '📊' },
]

export default function ConsumerAdmin() {
  const [activeTab, setActiveTab] = useState<ConsumerTab>('users')

  return (
    <div className="min-h-screen bg-[#0a0e14] relative overflow-hidden">
      <div className="fixed inset-0 pointer-events-none opacity-[0.02]" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #FFB84D 2px, #FFB84D 4px)'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-8">
        {/* Header */}
        <div className="mb-8 border-b border-[#FFB84D]/20 pb-6">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-[#FFB84D] text-3xl">👤</span>
            <h1 className="text-3xl font-bold text-[#FFB84D] tracking-wider uppercase" style={{
              fontFamily: '"Courier New", monospace',
              textShadow: '0 0 20px rgba(255, 184, 77, 0.3)',
              letterSpacing: '0.1em'
            }}>
              Consumer Admin
            </h1>
          </div>
          <p className="text-[#8b949e] text-sm ml-11" style={{ fontFamily: '"Courier New", monospace' }}>
            B2C Identity // Consumer User Management & Analytics
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="mb-6">
          <div className="flex gap-2">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`
                  relative px-6 py-3 font-mono text-sm uppercase tracking-wider transition-all duration-200
                  ${activeTab === tab.key
                    ? 'bg-[#FFB84D]/10 text-[#FFB84D] border-l-2 border-[#FFB84D] shadow-[0_0_20px_rgba(255,184,77,0.2)]'
                    : 'text-[#8b949e] hover:text-[#FFB84D]/70 hover:bg-[#FFB84D]/5'
                  }
                `}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === 'users' && <ConsumerUsers />}
        {activeTab === 'analytics' && <ConsumerAnalytics />}
      </div>
    </div>
  )
}
